export const DEV_PASSWORD_HEADER = 'dev-password';

/**
 * Explicit, session-only opt-in for Coming Soon staff preview (DEV-7046). Saturn grants preview only when this
 * header equals `COMING_SOON_PREVIEW_HEADER_VALUE` AND the request carries a valid `dev-password` on a verified
 * Firebase identity. The header alone grants nothing; any other value (or its absence) means preview is off.
 */
export const COMING_SOON_PREVIEW_HEADER = 'x-gtv-preview-coming-soon';
export const COMING_SOON_PREVIEW_HEADER_VALUE = 'true';

export const DEFAULT_REVCAT_OFFERING_ID = 'yearly_unlimited_baseline';

export const DEPRECATED_GET_DB_USER_METADATA_MSG = 'Deprecated — use GET /api/gtv/v3/user/db-metadata' as const;

// The discounted Galatea yearly subscription sold as a post-purchase cross-sell inside
// CandyJar. See the galatea-upsell module README (apps/galateatv) for the full flow. Shared
// between Saturn (webhook routing/grant) and the CandyJar client (Manage Subscription lookup).
export const GALATEA_UPSELL_PRODUCT_ID = 'com.galateatv.galatea_upsell.yearly';
export const GALATEA_CANDYJAR_UNLIMITED_ENTITLEMENT = 'candyjar_unlimited';

export * from './product-to-sku-lookup';
export * from './product-to-subscription-lookup';

export const EARLY_ACCESS_QA_VARIANT_HEADER = 'x-early-access-variant';
